<template>
  <div class="content" v-loading="loading">
    <div class="pageTitle">追踪稽查</div>

    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      :inline="true"
      class="search-form"
    >
      <el-form-item label="">
        <el-input
          v-model="form.logistics_code"
          clearable
          @keyup.enter.native="onSearch()"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch()">搜索</el-button>
      </el-form-item>
      <el-form-item class="mobile-link-action">
        <el-button v-if="isTrue" icon="el-icon-view" @click="showDetail">
          查看详情
        </el-button>
        <el-button
          v-if="isTrue"
          icon="el-icon-tickets"
          @click="showNewDetail"
        >
          查看详情(新版)
        </el-button>
        <el-button
          v-if="isTrue"
          type="primary"
          icon="el-icon-download"
          :disabled="!deliverData.length"
          @click="downloadFlowChart"
        >
          下载流程图
        </el-button>
        <el-button type="primary" @click="showLink = !showLink">
          手机端追踪稽查
        </el-button>
      </el-form-item>
    </el-form>

    <template v-if="isTrue">
      <!--
      <div class="result-summary">
        <div class="summary-item">
          <span class="summary-label">当前状态</span>
          <span class="status-tag" :style="statusTagStyle">
            {{ currentStatusText }}
          </span>
        </div>
        <div class="summary-item product-summary">
          <span class="summary-label">产品名称</span>
          <span class="product-name">{{ baseData.product_name || "--" }}</span>
        </div>
      </div>
       -->

      <div class="flow-section">
        <div class="section-title">物流信息</div>
        <logistics-flow-chart
          v-if="deliverData.length"
          ref="flowChart"
          :product-name="baseData.product_name || ''"
          :logistics-code="searchedCode"
          :current-status-text="currentStatusText"
          :current-status="baseData.status"
          :items="deliverData"
        />
        <div v-else class="empty-flow">
          <i class="el-icon-info"></i>
          <span>暂无物流记录</span>
        </div>
      </div>
    </template>

    <copy-link-dialog @handleClose="closeLink" v-if="showLink" />
  </div>
</template>

<script>
import copyLinkDialog from "./copyLinkDialog";
import LogisticsFlowChart from "./LogisticsFlowChart.vue";
import {
  filterLogisticsItems,
  getBaseStatusText,
  getStatusMeta,
} from "./traceUtils";

export default {
  name: "trace-manage",
  components: {
    copyLinkDialog,
    LogisticsFlowChart,
  },
  data() {
    return {
      form: {
        logistics_code: "",
      },
      baseData: {},
      deliverData: [],
      isTrue: false,
      loading: false,
      showLink: false,
      searchedCode: "",
    };
  },
  computed: {
    currentStatusText() {
      return getBaseStatusText(this.baseData);
    },
    statusTagStyle() {
      const meta = getStatusMeta(this.baseData.status);
      return {
        color: meta.color,
        backgroundColor: meta.backgroundColor,
        borderColor: meta.color,
      };
    },
  },
  watch: {
    "$route.query.logistics_code"(value) {
      const code = String(value || "").trim();
      if (!code) {
        this.form.logistics_code = "";
        this.resetResult();
        return;
      }
      if (code !== this.searchedCode) {
        this.form.logistics_code = code;
        this.onSearch(false);
      }
    },
  },
  created() {
    const code = String(this.$route.query.logistics_code || "").trim();
    if (code) {
      this.form.logistics_code = code;
      this.onSearch(false);
    }
  },
  methods: {
    closeLink() {
      this.showLink = false;
    },
    resetResult() {
      this.baseData = {};
      this.deliverData = [];
      this.isTrue = false;
      this.searchedCode = "";
    },
    syncRoute(code) {
      if (String(this.$route.query.logistics_code || "") === code) {
        return;
      }
      this.$router.replace({
        name: "traceManage",
        query: { logistics_code: code },
      });
    },
    onSearch(syncRoute = true) {
      const code = String(this.form.logistics_code || "").trim();
      if (!code) {
        this.$message({
          type: "warning",
          message: "请输入物流码",
        });
        return;
      }

      this.loading = true;
      this.$get("logistics", "/logistics.search", {
        lang: "",
        logistics_code: code,
      })
        .then((res) => {
          const data = res.data || {};
          this.baseData = data.base_info || {};
          this.deliverData = filterLogisticsItems(
            data.logistics_info,
            data.config_info
          );
          this.searchedCode = code;
          this.isTrue = true;
          if (syncRoute) {
            this.syncRoute(code);
          }
          this.loading = false;
        })
        .catch((error) => {
          this.resetResult();
          this.loading = false;
          this.$message({
            type: "error",
            message: error.message,
          });
        });
    },
    showDetail() {
      if (!this.searchedCode) {
        return;
      }
      this.$router.push({
        name: "traceManageDetail",
        query: { logistics_code: this.searchedCode },
      });
    },
    showNewDetail() {
      if (!this.searchedCode) {
        return;
      }
      this.$router.push({
        name: "traceManageDetailNew",
        query: { logistics_code: this.searchedCode },
      });
    },
    downloadFlowChart() {
      if (this.$refs.flowChart) {
        this.$refs.flowChart.download();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  .search-form {
    margin: 20px;
  }

  .mobile-link-action {
    float: right;
  }

  .result-summary {
    display: grid;
    grid-template-columns: minmax(180px, 0.8fr) minmax(260px, 1.4fr);
    gap: 24px;
    align-items: center;
    margin: 0 20px;
    padding: 18px 0;
    border-top: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }

  .summary-item {
    min-width: 0;
  }

  .summary-label {
    display: block;
    margin-bottom: 8px;
    color: #909399;
    font-size: 13px;
  }

  .status-tag {
    display: inline-block;
    max-width: 100%;
    padding: 6px 10px;
    border: 1px solid;
    border-radius: 4px;
    font-size: 15px;
    line-height: 20px;
    word-break: break-all;
  }

  .product-name {
    display: block;
    color: #303133;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    word-break: break-all;
  }

  .flow-section {
    margin: 24px 20px 30px;
  }

  .section-title {
    height: 40px;
    padding-left: 16px;
    border-left: 4px solid #409eff;
    background: #f5f7fa;
    color: #303133;
    font-size: 18px;
    line-height: 40px;
  }

  .empty-flow {
    display: flex;
    min-height: 180px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #909399;
    font-size: 15px;
  }
}

@media (max-width: 900px) {
  .content {
    .mobile-link-action {
      float: none;
    }

    .result-summary {
      grid-template-columns: 1fr;
      gap: 16px;
    }

  }
}
</style>
